<template>
    <select :id="selectId"
            class="go-vendor"
            v-bind:class="getClass"
            multiple>
        <option v-if="getPlaceHolder !== null" value="">{{$te(getPlaceHolder) ? $t(getPlaceHolder) : getPlaceHolder}}</option>
        <option
            v-for="(option, idx) in (getDVal !== null ? selectBoxOptions[getDVal] : selectBoxOptions)" :key="idx"
                v-bind:value="option[selectValue]"
                :data-icon="option.dataIcon !== 'undefined' ? option.dataIcon : null">
                <span v-if="option.vendor" :data-icon="option.vendor"></span>
            {{ getUseTranslate && $te(option[selectText]) ?$t(option[selectText]) : option[selectText]}}
        </option>
    </select>
</template>

<script>

    import { EventBus } from "./event-bus";

    export default {
        name: "SelectBoxMulti",
        data() {
            return {
                value: []
            }
        },
        props: {
            selectId: String,                   // 셀렉트 박스 ID(SPA 페이지에서 로딩된 DOM 중 유일한 값으로 지정할 것)
            selectBoxValue: Array | String,     // 초기 값 리스트
            selectClass: String,                // Select tag 사용자 정의 Class
            placeHolder: String,                // PlaceHolder value
            beforeText: {
                type :String,
                default: ''
            },                                  // Text value 앞에 추가될 문구(다국어 용)
            selectValue: {
                type: String,
                default: 'key'
            },                                  // Options key 값이 될  Attribute name
            selectText: {
                type: String,
                default: 'val'
            },                                  // Options text 표시값이 될  Attribute name
            dataInvalid: {
                type: Boolean | String,
                default: false
            },                                  // Validation Check flag
            disabled: {
                type: Boolean | String,
                default: false
            },                                  // Disabled flag
            useLabels: {
                type: Boolean | String,
                default: false
            },
            selectBoxOptions: {
                type: Array | Object,
                default: ()=>{return []}
            },
            useTranslate: {
                type: Boolean | String,
                default: false
            },                                  // i18n Translate 플래그
            dynamicValue: Number | String       // 동적 바인딩 사용 플래그
        },
        computed:{
            getClass:function(){
                let sClass = typeof(this.selectClass) !== 'undefined'
                    ? this.selectClass + ' ' + this.selectId
                    : this.selectId

                sClass = this.disabled ? sClass + ' ' + 'disabled' : sClass
                return sClass
            },
            getPlaceHolder: function() {
                return typeof(this.placeHolder) !== 'undefined' ? this.placeHolder : null
            },
            getUseLabels: function() {
                return typeof(this.useLabels) !== 'undefined' ? this.useLabels : false
            },
            getUseTranslate: function() {
                return typeof(this.useTranslate) !== 'undefined' ? this.useTranslate : false
            },
            getDVal: function() {
                return typeof(this.dynamicValue) !== 'undefined' ? this.dynamicValue : null
            }
        },
        mounted() {

            this.value = !this.selectBoxValue ? this.selectBoxValue : []
            if(!this.selectBoxOptions){
                this.selectBoxOptions = [];
            }

            EventBus.$on("changeLocale", e => {
                if(this.getPlaceHolder !== null){
                    //$('.type-checkbox').dropdown('refreshData');
                    //$(`#${this.selectId}`).dropdown('set exactly', this.selectBoxValue)

                }

                if(typeof(this.selectBoxValue) !== 'undefined'){
                    //$(`#${this.selectId}`).dropdown('set exactly', this.selectBoxValue)

                }
            });

            this.initSelectBox()
        },
        watch: {
            dataInvalid:function(){
                //this.dataInvalid ? $(`#${this.selectId}`).attr("data-invalid", true) : $(`#${this.selectId}`).removeAttr("data-invalid")
                this.dataInvalid ? $(`.go-vendor.${this.selectId}.ui.dropdown`).attr("data-invalid", true) : $(`.go-vendor.${this.selectId}.ui.dropdown`).removeAttr("data-invalid")
            },
            selectBoxValue: function(){
                //$(`#${this.selectId}`).dropdown('set exactly', this.selectBoxValue)
            }

        },
        methods: {
            initSelectBox: function() {
                let self = this;

                $(`#${this.selectId}`).dropdown({
                    useLabels: this.getUseLabels,
                    onChange: function(value, text, $choice) {
                        if( value.length > 1 ) {
                            $(`#${this.selectId}`).addClass('selected');
                        } else {
                            $(`#${this.selectId}`).removeClass('selected');
                        }
                        self.$emit('onSelectChange', {'id': self.selectId, 'value': value});
                    },

                });
                if(typeof(this.selectBoxValue) !== 'undefined') {
                    $(`#${this.selectId}`).dropdown('set value', this.selectBoxValue)
                }

            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/common/selectBoxMulti.vue